export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Panel.vue?vue&type=template&id=7680f018"


//////////////////
// WEBPACK FOOTER
// ./src/lib/panel/Panel.vue?vue&type=template&id=7680f018
// module id = null
// module chunks = 